import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["burger"]

  toggle(event) {
    event.preventDefault()
    const target = event.currentTarget.dataset.target
    const menuElement = document.querySelector(target)
    if (menuElement) {
      menuElement.classList.toggle("is-active")
    }
  }

  toggleMobile() {
    const target = this.burgerTarget.dataset.target
    const menuElement = document.querySelector(target)
    if (menuElement) {
      this.burgerTarget.classList.toggle("is-active")
      menuElement.classList.toggle("menu-mobile")
    }
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.element.querySelectorAll(".mega-menu.is-active").forEach(el => {
        el.classList.remove("is-active")
      })
    }
  }

  connect() {
    this._hideHandler = this.hide.bind(this)
    document.addEventListener("click", this._hideHandler)
  }

  disconnect() {
    document.removeEventListener("click", this._hideHandler)
  }
}
